import { FC, useEffect, useState } from "react";
import { Dialog } from "src/framework/components/commons/dialogs/Dialog";
import { InputSelectSimple } from "src/framework/components/forms/inputs/InputSelectSimple";
import { DEFAULT_PRIORIDADE_PROJETOS_VERTICAIS, LISTA_PRIORIDADE_PROJETOS_VERTICAIS } from "../constants";
import { Projeto } from "../types";
import { notifierStore } from "src/framework/store/NotifierStore";

export interface ProjetoPrioridadeDom extends Pick<Projeto, "id" | "prioridade"> {

}

export interface ProjetosPrioridadeProps {
    data: ProjetoPrioridadeDom | null;
    open: boolean;
    setOpen: (value: boolean) => void;
    applyConfirmation: (data: ProjetoPrioridadeDom) => void;
}

const ProjetosPrioridadeModel: FC<ProjetosPrioridadeProps> = ({ data, open, setOpen, applyConfirmation }) => {
    const [prioridadeState, setPrioridadeState] = useState<string>("");

    useEffect(() => {
        if (!data) {
            setPrioridadeState(DEFAULT_PRIORIDADE_PROJETOS_VERTICAIS);
        } else {
            setPrioridadeState(data.prioridade || DEFAULT_PRIORIDADE_PROJETOS_VERTICAIS);
        }
    }, [data]);

    return (
        <Dialog
            key="projetos-prioridade-modal"
            isOpen={open}
            title="Alteração de prioridade"
            onClose={() => setOpen(false)}
            content={
                <div className="row">
                    <div className="X12">
                        <InputSelectSimple
                            list={LISTA_PRIORIDADE_PROJETOS_VERTICAIS}
                            label="Prioridade"
                            value={prioridadeState}
                            onChange={(value) => {
                                setPrioridadeState(value);
                            }}
                        />
                    </div>
                </div>
            }
            actions={
                [
                    {
                        color: "secondary",
                        label: "Fechar",
                        onClick: () => {
                            setOpen(false);
                        },
                    },
                    {
                        color: "primary",
                        label: "Atualizar prioridade",
                        onClick: () => {
                            if (!prioridadeState) {
                                notifierStore.setNotifier({
                                    title: "Aviso!!!",
                                    content: ["Informe a prioridade do projeto"],
                                    timeOut: 3500,
                                    onClose: () => {
                                        notifierStore.setOpen(false);
                                    }
                                });
                                notifierStore.setOpen(true);
                                return;
                            }

                            if (!data) {
                                return;
                            }

                            try {
                                const persistData: ProjetoPrioridadeDom = {
                                    id: data.id,
                                    prioridade: prioridadeState,
                                }

                                applyConfirmation(persistData);
                                setPrioridadeState(DEFAULT_PRIORIDADE_PROJETOS_VERTICAIS);
                            } finally {
                                setOpen(false);
                            }
                        },
                    },
                ]
            }
        >
        </Dialog>
    )
}

export { ProjetosPrioridadeModel }